import { useMutation } from "@tanstack/react-query";
import useGlobalState from "global-state-hooks/useGlobalState";
import { sendMessageToOffice } from "utils/messageService";
import useUserDetails from "./useUserDetails";

export const useSendMessage = (callback: () => void) => {
  const { user: details } = useUserDetails();

  const { clinicId } = useGlobalState();

  const mutation = useMutation({
    mutationFn: sendMessageToOffice,
    onSuccess: () => {
      callback && callback();
    },
  });

  const sendMessage = async ({
    message,
    file,
    audio,
  }: {
    message: string;
    file?: File;
    audio?: Blob;
  }) => {
    try {
      await mutation.mutateAsync({
        chatToken: details?.token,
        message,
        file,
        audio,
        clinicId,
      });
    } catch (error) {
      console.error("Failed to send message:", error);
      throw error;
    }
  };

  return [sendMessage, mutation.isLoading] as const;
};
